import { renderIcon } from './helpers/renderIcon';
import scrollTo from './helpers/scrollTo';

const SELECTORS = {
    HOLDER: '.js-page-anchors',
    LIST: '.js-page-anchors-list',
};

const ITEM_CLASS = 'page-anchors__list-item';
const LINK_CLASSES = ['page-anchors__list-item__link', 'icon-link', 'icon-link--icon-left'];
const ICON_CLASSES = ['icon-link__icon', 'page-anchors__list-item__link__icon'];
const offset = 200;

function initPageAnchors() {
    const pageAnchorHolder = document.querySelector(SELECTORS.HOLDER);

    if (pageAnchorHolder) {
        const pageAnchorList = pageAnchorHolder.querySelector(SELECTORS.LIST);
        const headerNodes = getHeaderNodes();
        const targetLevel = headerNodes.two.length > 1 ? 'two' : 'three';
        const { kindengezinPath } = pageAnchorHolder.dataset;

        headerNodes[targetLevel].forEach((target, i) => {
            const listItem = renderItem();
            const link = renderLink({ i, target, kindengezinPath });

            listItem.appendChild(link);
            pageAnchorList.appendChild(listItem);
        });
    }
}

function getHeaderNodes() {
    return {
        two: filterHeaderNodes('h2'),
        three: filterHeaderNodes('h3'),
    };
}

function filterHeaderNodes(tag) {
    const nodes = [];

    [...document.getElementById('main').getElementsByTagName(tag)].forEach((header) => {
        if (!header.classList.contains('visually-hidden')) {
            nodes.push(header);
        }
    });

    return nodes;
}

function renderItem() {
    const item = document.createElement('li');
    item.classList.add(ITEM_CLASS);

    return item;
}

function renderLink({ i, target, kindengezinPath }) {
    const { textContent } = target;
    const link = document.createElement('a');
    const title = textContent.replace(/\s+/g, ' ').trim();
    const icon = renderIcon(kindengezinPath, 'arrow-down', ICON_CLASSES);

    target.setAttribute('id', `anchored-section-${i + 1}`);

    link.setAttribute('href', `#anchored-section-${i + 1}`);
    link.classList.add(...LINK_CLASSES);
    link.textContent = title;
    link.prepend(icon);

    link.addEventListener('click', (e) => {
        e.preventDefault();
        scrollTo({ target, offset });
    });

    return link;
}

export { initPageAnchors };
